const getReturningUserData = require("./getReturningUserData");

/**
 * @return {boolean}
 */
module.exports = function isReturningUserDataAvailable() {
    const returningUserData = getReturningUserData();
    return !!returningUserData;
}